import React, { Component } from "react";
import "./Select.css";
import jcf from "jcf/dist/js/jcf";

export default class Select extends Component {
  constructor() {
    super();

    this.change = this.change.bind(this);

    this.state = {
    };
  }

  componentDidMount() {
    jcf.setOptions("Select", {
      wrapNative: false,
      wrapNativeOnMobile: true,
      maxVisibleItems: 6
    });
    jcf.replaceAll();
    setInterval(function () {
      jcf.replaceAll();
    }, 500);
  }

  componentWillUnmount() {
  }

  change(e) {
    this.props.onChangeValue(this.props.id, e.target.value);
  }

  render() {
    let iconIdentifier = "";
    switch (this.props.type) {
      case "email":
        iconIdentifier = "email";
        break;
      case "phone":
        iconIdentifier = "phone";
        break;
      case "user":
        iconIdentifier = "usericon";
        break;
      case "city":
        iconIdentifier = "city";
        break;
      case "country":
        iconIdentifier = "country";
        break;
      case "address":
        iconIdentifier = "address";
        break;
      case "currency":
        iconIdentifier = "currencyicon";
        break;
      case "language":
        iconIdentifier = "languageicon";
        break;
      default:
        break;
    }
    let props = this.props;
    return (
      <React.Fragment>
        <div className="noku-select" id={this.props.id}>
          <label htmlFor={props.label}>{props.label} {!!this.props.required ? <div className="red-required">*</div> : null}</label>
          <div className={iconIdentifier}>
            <select onChange={this.change} value={props.defaultValue} disabled={this.props.readonly}>
              {props.elementConfig.options.map((option, index) => (
                <option
                  className={option.customClass}
                  key={option.value}
                  value={option.value}
                /*defaultValue={props.selectedIndex ? index === Number(props.selectedIndex) : index === 0}*/
                >
                  {option.displayValue}
                </option>
              ))}
            </select>
          </div>
        </div>
      </React.Fragment>
    );
  }
}